<div *ngFor="let modal of modalList" appAutoFocus>

  <!-- standard modal -->
  <section class="modal modal--{{modal.type}} ammendError" *ngIf="modal.modalType === 'standard'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title"><i class="icon" *ngIf="modal.type === 'danger'">alert</i>{{modal.title}}</h4>
        </div>
        <div class="modal-body" [innerHtml]="modal.content">
        </div>
        <div class="modal-footer clearfix" *ngIf="modal.routerLink">
          <a id="modal-submit" class="{{modal.buttonClass}}" routerLink="/{{modal.routerLink}}"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>
        <div class="modal-footer clearfix" *ngIf="modal.buttonLink">
          <a id="modal-submit" class="{{modal.buttonClass}}" href="{{modal.buttonLink}}" target="_blank"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- standard modal - no close -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'standardNoClose'">

    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!--<button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>-->
          <h4 class="modal-title"><i class="icon" *ngIf="modal.type === 'danger'">alert</i>{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
        </div>
        <div class="modal-footer clearfix" *ngIf="modal.routerLink">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
          <div class="hr-text text-center text-muted margin-top-8 margin-bottom-8">
            <span>or</span>
          </div>
          <a id="modal-submit" class="{{modal.buttonClass}}" routerLink="/{{modal.routerLink}}"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>

        <div class="modal-footer clearfix" *ngIf="modal.buttonLink">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
          <div class="hr-text text-center text-muted margin-top-8 margin-bottom-8">
            <span>or</span>
          </div>
          <a id="modal-submit" class="{{modal.buttonClass}}" href="{{modal.buttonLink}}" target="_blank"
            (click)="removeClasses()">
            {{modal.buttonText}}
          </a>
        </div>
      </div>
    </div>
  </section>

  <!-- resend booking email -->
  <section class="modal mmbv2 modal--{{modal.type}}" *ngIf="modal.modalType === 'resendConfirm'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h3 class="modal-title">{{modal.title}}</h3>
        </div>
        <div class="modal-body btn-action">
          <button class="btn btn__outlined-red width-100" (click)="closeModal($event)">
            <span>
              {{this.appCopy.panelHeader['cancelButton' + this.selectedLanguage]}}
            </span>
          </button>
          <button class="btn btn__purple width-100" [disabled]="showLoader" (click)="resendClickHandler()">
            <span>{{this.appCopy.panelHeader['resendEmailBookingButton' + this.selectedLanguage]}}</span>
            <div class="loader-container-btn" *ngIf="showLoader">
              <div class="loader loader--white">
                <svg class="circular" viewBox="25 25 50 50">
                  <circle class="path" cx="50" cy="50" r="20" />
                </svg>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
  </section>
  <!-- delete complete booking modal -->
  <section class="modal mmbv2 cancelReason modal--{{modal.type}}" *ngIf="modal.modalType === 'deleteBooking'">
    <div class="modal-dialog">
      <div class="modal-content">
        <ng-container *ngIf="modal.productPlan === 'Fixed' && !showCanncelReasonsAfterFixed">
          <div class="modal-header">
            <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          </div>
          <div class="modal-body">
            <h4 class="padding-top-32">
              {{this.appCopyModal.panelHeader['fixedCancelMsg' + this.selectedLanguage]}}
            </h4>
          </div>
          <div class="modal-footer ">
              <div class="btn-action">
                <button type="button" class="btn btn__purple" (click)="closeModal($event)">{{this.appCopyModal.panelHeader['goBack' + this.selectedLanguage]}}</button>
                <button type="button" class="btn btn__red" (click)="confirmCancelFromFixed()">{{this.appCopyModal.panelHeader['confirm' + this.selectedLanguage]}}</button>
              </div>
          </div>
        </ng-container>
        <ng-container *ngIf="showCanncelReasonsAfterFixed">
          <form #formCancelReason="ngForm" mame="formCancelReason" id="formCancelReason"
            (ngSubmit)="submitCancelReason()" novalidate>
                  <div class="modal-header">
                    <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
                    <h4 class="modal-title">{{modal.title}}</h4>
                    <ng-container *ngIf="modal.productPlan !== 'Fixed' else fixedPlanMsg">
                      <!-- refund reasons -->
                      <!-- re arrange the conditions show only one reason at a time -->
                      <!-- if it is airline issue than show it on priority then check for non airline issue if is it in cooling period then show cooling period refund message if is out of cooling period then show the respective message and if it is not in cooling period and collection time has been passed then show non airline no refun message -->
                      <ng-container *ngIf="inTheCoolingPeriod else notCoolingPeriodMsg">
                        <p class="text-dark-blue margin-bottom-0">{{appCopy.panelHeader['refundCoolingPeriod' +
                          selectedLanguage].replace('%s', '100%').replace('%d', (cutOffTimeWindow | amDateFormat:'hh:mma' : languageCode)
                          + ' ' + (cutOffTimeWindow | date :'dd MMMM' : languageCode))}}</p>
                      </ng-container>

                      <ng-template #notCoolingPeriodMsg>
                        <ng-container *ngIf="airlineIssue else nonAirlineIssue">
                          <p class="text-dark-blue margin-bottom-0">{{ appCopy.panelHeader['refundAirlineIssue' + selectedLanguage] }}</p>
                        </ng-container>


                        <ng-template #nonAirlineIssue>
                          <p *ngIf="!inTheCoolingPeriod && !collectionTimePassed" class="text-dark-blue margin-bottom-0">
                            {{appCopy.panelHeader['refundCoolingPeriod' + selectedLanguage].replace('%s', modal.data?.amountToRefund |
                            currency: undefined : modal.data?.currencySymbol:'1.0-2').replace('%d', (cutOffTimeWindow |
                            amDateFormat:'hh:mma' : languageCode) + ' ' + (cutOffTimeWindow | date :'dd MMMM' : languageCode))}}</p>

                          <p *ngIf="collectionTimePassed" class="text-dark-blue margin-bottom-0">{{
                            appCopy.panelHeader['nonAirlineNoRefund' + selectedLanguage] }}</p>
                        </ng-template>
                      </ng-template>


                      <p><a class="btn-refund-policy" target="_blank"
                          [href]="'https://portrltdqa.wpengine.com/' + languageCode + '/terms-and-conditions/#refund-policy'">{{
                          appCopy.panelHeader['refundPolicyLink' + selectedLanguage] }}</a></p>

                    </ng-container>

                    <ng-template #fixedPlanMsg>
                      <p class="text-dark-blue margin-bottom-0">{{ appCopy.panelHeader['refundForFixed' + selectedLanguage] }}</p>
                    </ng-template>
                  </div>
                  <div class="modal-body">
                    <!-- <p class="text-muted">{{modal.content}}</p> -->
                    <!-- <div class="get-in-touch">
                      <div class="flex">
                        <div class="flex margin-right-16">
                          <img class="margin-right-16" src="./images/modal/modal_life-ring-telephone.svg" alt="">
                          <a href="tel:+442033846677">+44 203 384 6677</a>
                        </div>
                        <button type="button" class="btn btn-sm btn-chat" (click)="handleChatClick()">{{ appCopy.panelHeader['liveChatText' + selectedLanguage] }}</button>
                      </div>
                    </div> -->
                    <h4>{{ appCopy.panelHeader['helpUsUnderstandText' + selectedLanguage] }}</h4>
                    <p>{{ appCopy.panelHeader['whyYouWantToCancelBookingText' + selectedLanguage] }}</p>
                    <div *ngFor="let reason of cancelReasons; let i = index;">
                      <div class="radio radio--default radio--small">
                        <div class="reason-{{i}}">
                          <input type="radio" name="cancelReason" id="reason{{i}}" (change)="onReasonUpdate(i)" [(ngModel)]="cancelReasonSelected" [value]="i" required>
                          <label for="reason{{i}}">{{ appCopy.panelHeader[reason + selectedLanguage] }}</label>
                          <ng-template [ngIf]="cancelReasonSelected === i && subReasons[cancelReasons[i]]">
                            <div *ngFor="let subReason of subReasons[cancelReasons[i]]; let j = index;" class="radio radio--default radio--small subreason-block">
                            <div class="subreason-{{i}}-{{j}}">
                              <input type="radio" name="subReason" id="subreason{{i}}-{{j}}" [(ngModel)]="selectedCancelSubReason" [value]="j" *ngIf="subReasons[cancelReasons[i]]"
                                [required]="subReason === 'Other' || subReason === 'Description' ? false : true">
                              <label for="subreason{{i}}-{{j}}">{{ appCopy.panelHeader[subReason + selectedLanguage] || subReason }}</label>
                            </div>
                          </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                    <div class="form-group cancelReasonCustom" *ngIf="cancelReasonSelected === cancelReasons.length - 1 || cancelReasons[cancelReasonSelected] === 'Technical issue'">
                      <input class="form-control form-control--no-label" [ngClass]="{ 'has-error' : cityInvalid, 'has-error': cancelReasonCustom.length > 500 }"
                      id="cancelReasonCustom" name="cancelReasonCustom" placeholder="{{appCopy.panelHeader['otherReasonPlaceholder'+selectedLanguage]}}" [(ngModel)]="cancelReasonCustom"
                      [required]="selectedCancelSubReason !== null && subReasons[cancelReasons[cancelReasonSelected]] && subReasons[cancelReasons[cancelReasonSelected]][selectedCancelSubReason] === 'Description' ? false : true">
                      <p class="help-block text-danger" *ngIf="cancelReasonCustom.length > 500">{{ appCopy.panelHeader['invalidCancelReason'+selectedLanguage] }}</p>
                    </div>
                    <div class="img-block" *ngIf="(cancelReasonSelected === 0 || cancelReasonSelected === 3) && !occReasonAdded">
                      <label>{{ appCopy.panelHeader['uploadFile'+selectedLanguage] }}
                        <div class="bagtooltip margin-left-8">
                          <span class="icon-span icon-span-small tooltip-trigger-text">
                            <span class="icon-information icon-black icon_12"></span>
                          </span>
                          <span class="tooltiptext tooltip-top">{{ appCopy.panelHeader['browseFileTooltip'+selectedLanguage] }}</span>
                        </div>
                      </label>
                      <label class="uploadImage" for="uploadImage">
                        <span class="icon-logout"></span>{{ appCopy.panelHeader['browseFile'+selectedLanguage] }}
                        <input id="uploadImage" type="file" #fileInput (change)="onFileSelected($event)" multiple accept="image/jpeg,image/png,image/svg+xml,application/pdf" placeholder="Browse File" style="display: none;" />
                      </label>
                      <div class="uploaded-images" *ngIf="uploadedImages.length > 0">
                        <div class="image-preview" *ngFor="let image of uploadedImages; let i = index;">
                          <img *ngIf="image.preview" [src]="image.preview" alt="Preview" />
                          <span *ngIf="!image.preview" class="file-name">{{ image.file.name }}</span>
                          <button type="button" [ngStyle]="{'right': !image.preview ? '-16px' : '-5px'}" class="remove-btn" (click)="removeImage(i)">×</button>
                        </div>
                      </div>
                      <div class="erroMsg" *ngIf="uploadedImagesError">{{ appCopy.panelHeader['uploadFileErrorMsg'+selectedLanguage] }}</div>
                      <div class="erroMsg" *ngIf="uploadedImagesSizeError">{{ appCopy.panelHeader['uploadFileErrorSizeMsg'+selectedLanguage] }}</div>
                      <div class="erroMsg" *ngIf="uploadedImagesFormatError">{{ appCopy.panelHeader['uploadFileErrorFormatMsg'+selectedLanguage] }}</div>
                    </div>
                  </div>
                  <div class="modal-footer ">
                    <div class="btn-action">
                    <button *ngIf="!cancelReasonSubmitted" type="submit" [disabled]="cancelReasonSelected === i || cancelReasonSelected === null" class="btn btn__outlined"
                          [disabled]="formCancelReason.invalid || cancelReasonCustom.length > 500">
                          {{modal.buttonText}}
                        </button>
                        <ng-container *ngIf="modal.productPlan !== 'Fixed'">
                          <button *ngIf="cancelReasonSelected === 3 && !occReasonAdded && !cancelReasonSubmitted" type="button"  class="btn btn__purple firstDatePicker">{{ appCopy.panelHeader['changeMyFlightButton'+selectedLanguage] }}
                          <app-datepicker
                          [selectedDate]="modal.flightData[0].departureDateTimeDetails.scheduledDate"
                          [minDate]="minDate"
                          [maxDate]="maxDate"
                          [disableDates]="disableDates"
                          [forAmendFlight]="true"
                          (dateChange)="dateChanged($event)"
                          >
                        </app-datepicker>
                        </button>
                        </ng-container>

                    <!-- (cancelReasonSubmitted && modal.flightData[0].airlineCode !== 'BA') -->
                    <div class="modal-cancel-confirmation width-100"
                      *ngIf="(cancelReasonSubmitted && cancelReasonSelected !== 0) || cancelReasonSubmitted">
                      <p [innerHTML]="appCopy.panelHeader['confirmChoiceText'+selectedLanguage]"></p>
                      <ng-container *ngIf="occReasonAdded else customer" >
                        <div class="btn-action">
                          <button (click)="closeModal($event)" type="button" class="btn btn__purple">
                            {{ appCopy.panelHeader['keepMyBookingButton'+selectedLanguage] }}
                          </button>
                          <button type="button" class="btn btn__red"
                            (click)="deleteBooking(formCancelReason.value, modal.bookingReference, modal.bookingJourneyReference, modal.userToken)">
                            {{ appCopy.panelHeader['cancelMyBookingButton'+selectedLanguage] }}
                          </button>
                        </div>
                      </ng-container>
                      <ng-template #customer>
                        <ng-container *ngIf="modal?.productPlan === 'Fixed' else notFixed">
                          <div class="btn-action">
                            <button (click)="closeModal($event)" type="button" class="btn btn__purple">
                              {{ appCopy.panelHeader['keepMyBookingButton'+selectedLanguage] }}
                            </button>
                            <button type="button" class="btn btn__red"
                              (click)="deleteBooking(formCancelReason.value, modal.bookingReference, modal.bookingJourneyReference, modal.userToken)">
                              {{ appCopy.panelHeader['cancelMyBookingButton'+selectedLanguage] }}
                            </button>
                          </div>
                        </ng-container>
                        <ng-template #notFixed>
                          <p class="desc" *ngIf="cancelReasonSelected === 3" [innerHTML]="appCopy.panelHeader['confirmChoiceTextDesc'+selectedLanguage]"></p>
                          <div class="btn-action">
                            <button *ngIf="cancelReasonSelected !== 3" (click)="closeModal($event)" type="button" class="btn btn__purple">
                              {{ appCopy.panelHeader['keepMyBookingButton'+selectedLanguage] }}
                            </button>
                            <button *ngIf="cancelReasonSelected === 3" type="button" class="btn btn__purple">
                                {{ appCopy.panelHeader['changeMyFlightButton'+selectedLanguage] }}
                                <app-datepicker
                                [selectedDate]="modal.flightData[0].departureDateTimeDetails.scheduledDate"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                [disableDates]="disableDates"
                                [forAmendFlight]="true"
                                (dateChange)="dateChanged($event)"
                                >
                              </app-datepicker>
                            </button>
                            <button type="button" class="btn btn__red"
                              (click)="deleteBooking(formCancelReason.value, modal.bookingReference, modal.bookingJourneyReference, modal.userToken)">
                              {{ appCopy.panelHeader['cancelMyBookingButton'+selectedLanguage] }}
                            </button>
                          </div>
                        </ng-template>
                      </ng-template>
                    </div>
                      <!-- <a class="link link--gray" href="javascript:void(0)" (click)="resetReasons()">{{ appCopy.panelHeader['chooseDifferentOptionLink'+selectedLanguage] }}</a> -->
                    </div>

                    <!-- *ngIf="cancelReasonSubmitted && cancelReasonSelected === 0 && modal.flightData[0].airlineCode === 'BA'" -->
                    <div class="modal-cancel-confirmation margin-top-24" style="display: none;">
                      <img class="margin-bottom-12" src="./images/modal/modal_ba_logo.svg" alt="">
                      <p [innerHTML]="appCopy.panelHeader['boardingPassNotNeededBAText'+selectedLanguage]"></p>
                      <ul>
                        <li class="row">
                          <div class="col-xs-2 col-sm-1">
                            <img src="./images/modal/modal_tick.svg" alt="">
                          </div>
                          <div class="col-xs-10 col-sm-11">
                            <p [innerHTML]="appCopy.panelHeader['checkInOnlineBAText'+selectedLanguage]"></p>
                          </div>
                        </li>
                        <li class="row">
                          <div class="col-xs-2 col-sm-1">
                            <img src="./images/modal/modal_tick.svg" alt="">
                          </div>
                          <div class="col-xs-10 col-sm-11">
                            <p>{{ appCopy.panelHeader['visaChildrenNoProblemText'+selectedLanguage] }}</p>
                          </div>
                        </li>
                        <li class="row">
                          <div class="col-xs-2 col-sm-1">
                            <img src="./images/modal/modal_tick.svg" alt="">
                          </div>
                          <div class="col-xs-10 col-sm-11">
                            <p>{{ appCopy.panelHeader['directLinkWithBASystemText'+selectedLanguage] }}</p>
                          </div>
                        </li>
                      </ul>
                      <div class="row margin-bottom-12">
                        <div class="col-sm-8">
                          <button type="button" class="btn btn-primary btn-block" (click)="closeModal($event)">
                            {{ appCopy.panelHeader['GreatKeepMyBookingButton'+selectedLanguage] }}
                          </button>
                        </div>
                      </div>
                      <a class="link link--gray" href="javascript:void(0)" (click)="resetReasons()">{{ appCopy.panelHeader['chooseDifferentOptionLink'+selectedLanguage] }}</a>
                      {{ appCopy.panelHeader['orText'+selectedLanguage] }}
                      <a class="link link--gray" href="javascript:void(0)"
                        (click)="deleteBooking(formCancelReason.value, modal.bookingReference, modal.bookingJourneyReference, modal.userToken)">{{ appCopy.panelHeader['cancelAnyWayLink'+selectedLanguage] }}</a>
                    </div>
                  </div>
          </form>
          <div class="loader-container-btn" *ngIf="showLoader">
            <div class="loader loader--white">
              <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" />
              </svg>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </section>

  <!-- incorrect flight direction modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'flightDirection'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!--<button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>-->
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
          <div class="hr-text text-center text-muted margin-top-8 margin-bottom-8">
            <span>or</span>
          </div>
          <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block" (click)="continueBooking()">
            {{ modal.buttonText }}
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- incorrect flight direction modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'flightNoService'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <!--<button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>-->
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted" [innerHtml]="modal.content"></p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="goToQuote()">
            Search again
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- admin filters modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'adminFilters'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <form name="formAdminFilters" novalidate>
            <app-admin-filters [appCopy]="appCopy" [selectedLanguage]="selectedLanguage"
              [filtersSelected]="filtersSelected" (appliedFilters)="filterFormValues($event)">
            </app-admin-filters>
          </form>
          <p class="help-block text-danger" *ngIf="showDateError">{{
            appCopy.panelHeader['errorFilterDateInvalid'+selectedLanguage] }}</p>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <button type="button" class="btn btn-primary btn-ghost btn-block"
                (click)="clearFilters($event); closeModal($event)">{{
                appCopy.panelHeader['clearAllFiltersButton'+selectedLanguage] }}</button>
            </div>
            <div class="col-sm-6">
              <button type="button" (click)="setAdminFilters($event)" class="btn btn-primary btn-block"
                [disabled]="filtersDisabled">
                {{ modal.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- flight not listed -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'flightNotListed'">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
          <button type="button" class="btn btn-primary btn-lg btn-block" (click)="showFlightSearch('flightNumber')">
            Enter my Flight Number
          </button>
        </div>
        <div class="modal-footer text-primary bg-primary-light padding-top-16">
          <p>Or you could use Airport Delivery</p>
          <hr class="margin-top-16 margin-bottom-16">
          <div class="media margin-bottom-16">
            <div class="media-left media-middle">
              <i class="spritre sprite--product-airport"></i>
            </div>
            <div class="media-body media-middle">
              <h5 class="margin-top-0 margin-bottom-0">We deliver your bags to the airport</h5>
              <p>You collect them from us before checking in</p>
            </div>
          </div>
          <button type="button" class="btn btn-primary btn-ghost btn-lg btn-block"
            (click)="goToSDSFlightSearch($event)">
            Book Airport Delivery
          </button>
        </div>
      </div>
    </div>
  </section>

  <!-- delete card modal -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'deleteCard'">
    <div class="modal-dialog w-500">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p class="text-muted">{{modal.content}}</p>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <button type="button" class="btn btn-primary btn-lg btn-block" (click)="closeModal($event)">{{
                modal.cancelButtonText }}</button>
            </div>
            <div class="col-sm-6">
              <button type="submit" class="btn btn-danger btn-lg btn-block" [disabled]="isDisabled"
                (click)="deleteCard(modal.cardReference, modal.userId, modal.userToken)">
                {{ modal.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- miles relogin confirmation -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'milesRelogin'">
    <div class="modal-dialog w-500">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title">{{modal.title}}</h4>
        </div>
        <div class="modal-body">
          <p>{{modal.content}}</p>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-sm-6">
              <button type="button" class="btn btn-default btn-lg btn-block" (click)="closeModal($event)">{{
                modal.cancelButtonText }}</button>
            </div>
            <div class="col-sm-6">
              <button type="submit" class="btn btn-purple btn-lg btn-block" [disabled]="isDisabled"
                (click)="milesLoginRedirect()">
                {{ modal.buttonText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!--priceBreakdown -->
  <section class="modal modal--{{modal.type}}" *ngIf="modal.modalType === 'priceBreakdown'">
    <div class="modal-dialog w-500">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" (click)="closeModal($event)"><i class="icon">cross</i></button>
          <h4 class="modal-title text-dark-blue">{{appCopyModal.panelHeader['priceBreakdownTitle'+this.selectedLanguage]
            }}</h4>
        </div>
        <div class="modal-body">
          <div class="grid gap-8">
            <ng-container *ngIf="modal.priceBreakdown.isD2dService; then d2d; else notD2d"></ng-container>

            <ng-template #d2d>
              <div *ngIf="modal.priceBreakdown.basePriceDep > 0" class="flex-always flex--space-between">
                <div>
                  <p>{{appCopyModal.panelHeader['basePriceDep'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                  :''}}{{modal.priceBreakdown.basePriceDep}}
                </p>
              </div>

              <div *ngIf="modal.priceBreakdown.basePriceArrival > 0" class="flex-always flex--space-between">
                <div>
                  <p>{{appCopyModal.panelHeader['basePriceArrival'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                  :''}}{{modal.priceBreakdown.basePriceArrival}}
                </p>
              </div>

              <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.oversizeItemSurcharge > 0">
                <div>
                  <p>{{appCopyModal.panelHeader['oversizeItemSurcharge'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? '
                  ' :''}}{{modal.priceBreakdown.oversizeItemSurcharge}}</p>
              </div>

              <div *ngIf="modal.priceBreakdown.sbbDiscountDep > 0" class="flex-always flex--space-between">
                <div>
                  <p>{{appCopyModal.panelHeader['sbbDiscountDep'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                  :''}}{{modal.priceBreakdown.sbbDiscountDep}})
                </p>
              </div>

              <div *ngIf="modal.priceBreakdown.sbbDiscountArrival > 0" class="flex-always flex--space-between">
                <div>
                  <p>{{appCopyModal.panelHeader['sbbDiscountArrival'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' ' :''}}
                  {{modal.priceBreakdown.sbbDiscountArrival}})
                </p>
              </div>

            </ng-template>

            <ng-template #notD2d>

              <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.basePrice > 0">
                <div>
                  <p>{{appCopyModal.panelHeader['basePrice'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? '
                  ' :''}}{{modal.priceBreakdown.basePrice}}</p>
              </div>

              <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.oversizeItemSurcharge > 0">
                <div>
                  <p>{{appCopyModal.panelHeader['oversizeItemSurcharge'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? '
                  ' :''}}{{modal.priceBreakdown.oversizeItemSurcharge}}</p>
              </div>

              <div *ngIf="modal.priceBreakdown.sbbDiscount > 0" class="flex-always flex--space-between">
                <div>
                  <p>{{appCopyModal.panelHeader['sbbDiscount'+selectedLanguage]}}</p>
                </div>
                <p class="discount-price">
                  ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                  :''}}{{modal.priceBreakdown.sbbDiscount}})
                </p>
              </div>

            </ng-template>

            <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.promoCodesApplied !== null">
              <div>
                <p>
                  <ng-container
                    *ngIf="modal.priceBreakdown.promoCodesApplied[0] === 'MilesJulyDiscount' else otherPromoCode">
                    {{appCopyModal.panelHeader['discountMM'+selectedLanguage]}}
                  </ng-container>
                  <ng-template #otherPromoCode>
                    {{appCopyModal.panelHeader['discount'+selectedLanguage]}}
                    ({{modal.priceBreakdown.promotionRewardType === 2 ?
                    modal.priceBreakdown.promotionRewardAmount+'%' : modal.priceBreakdown.currencySymbol +
                    (modal.priceBreakdown.promotionRewardAmount /
                    100)}})
                  </ng-template>
                  {{appCopyModal.panelHeader['promoCode'+selectedLanguage]}}
                </p>
              </div>
              <p class="discount-price">
                ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                :''}}{{modal.priceBreakdown.discount}})</p>
            </div>

            <div class="flex-always flex--space-between" *ngIf="modal.priceBreakdown.milesDiscountApplied">
              <div>
                <p>{{appCopyModal.panelHeader['milesDiscount'+selectedLanguage]}}</p>
              </div>
              <p class="discount-price">
                ({{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
                :''}}{{modal.priceBreakdown.milesDiscountedPrice}})</p>
            </div>

          </div>
        </div>
        <div class="modal-footer">

          <div class="flex-always flex--space-between">
            <div class='text-primary'>
              <p>{{appCopyModal.panelHeader['total'+selectedLanguage]}}</p>
            </div>
            <p class="text-primary">
              {{modal.priceBreakdown.currencySymbol}}{{modal.priceBreakdown.currencySymbol==="CHF"? ' '
              :''}}{{modal.priceBreakdown.total}} </p>
          </div>

        </div>
      </div>
    </div>
  </section>

  <app-modal-add-password *ngIf="modal.modalType === 'addPasswordModal'" [appCopy]='appCopyModal'
    [selectedLanguage]='selectedLanguage' [modalData]="modal">
  </app-modal-add-password>

  <app-remove-service-modal *ngIf="modal.modalType === 'removeService'" [modalData]="modal">
  </app-remove-service-modal>

  <app-modal-time-slot-expired *ngIf="modal.modalType === 'timeSlotExpried'" [modalData]="modal">
  </app-modal-time-slot-expired>

  <app-hubdrop-info *ngIf="modal.modalType === 'hubdropInfo'" [appCopy]='appCopyModal'
    [selectedLanguage]='selectedLanguage' [modalData]="modal"></app-hubdrop-info>

  <app-save-pereferences-modal *ngIf="modal.modalType === 'savePereferences' && dataLoaded" [appCopy]='appCopyModal'
    [selectedLanguage]='selectedLanguage' [modalData]="modal" [modalList]="modalList" (closeModal)="closeModal($event)">
  </app-save-pereferences-modal>

  <div class="modal-backdrop"></div>
</div>